import { render } from "./ShareByMessage.vue?vue&type=template&id=b6f0641e&scoped=true&ts=true"
import script from "./ShareByMessage.vue?vue&type=script&lang=ts"
export * from "./ShareByMessage.vue?vue&type=script&lang=ts"

import "./ShareByMessage.vue?vue&type=style&index=0&id=b6f0641e&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6f0641e"]])

export default __exports__